import { apiUrl } from "../../../../utils/api.js";

export async function fetchReturnCodeForCaller({ slug }) {
  const params = new URLSearchParams();
  if (slug) params.set("slug", slug);
  const res = await fetch(apiUrl(`/api/v1/auth/return_code?${params.toString()}`), {
    method: "POST",
    credentials: "include",
  });
  if (!res.ok) return null;
  const data = await res.json().catch(() => null);
  return data?.code ? { code: data.code, expires_in: data.expires_in } : null;
}

export async function fetchAuthStatus() {
  try {
    const res = await fetch(apiUrl("/api/v1/auth/status"), { credentials: "include" });
    if (!res.ok) return { ok: false, authenticated: false, data: null };
    const data = await res.json().catch(() => null);
    return { ok: true, authenticated: Boolean(data?.authenticated), data };
  } catch {
    return { ok: false, authenticated: false, data: null };
  }
}
